import {
  DateTimePickerMui,
  DateTimePickerNative,
  DateTimePickerProps,
} from "@msys/ui";
import { FormControl, FormHelperText } from "@mui/material";
import { useFormikContext } from "formik";
import { get, isString } from "lodash-es";
import { Moment } from "moment";
import { ChangeEvent } from "react";
import { browserHasInputDateTime } from "../../featureDetection.js";

export interface Props extends Omit<DateTimePickerProps, "value" | "onChange"> {
  id?: string;
  fullWidth?: boolean;
  required?: boolean;
  name: string;
  value?: Moment | null;
  onChange?: (
    e: ChangeEvent<HTMLInputElement> | null,
    newValue: Moment | null
  ) => void;
}

export const DateTimePickerField = ({
  fullWidth = true,
  name,
  value,
  onChange,
  ...otherProps
}: Props) => {
  const { values, setFieldValue, errors } =
    useFormikContext<Record<string, any>>();

  const error = get(errors, name);

  const Component = browserHasInputDateTime
    ? DateTimePickerNative
    : DateTimePickerMui;

  return (
    <FormControl
      fullWidth={fullWidth}
      required={otherProps.required}
      error={Boolean(error)}
      disabled={otherProps.disabled}
    >
      <Component
        error={Boolean(error)}
        name={name}
        value={value ?? get(values, name) ?? null}
        onChange={
          onChange ??
          ((e, date) => {
            if (otherProps.isClearable || (date && date.isValid())) {
              setFieldValue(name, date ? (date.isValid() ? date : null) : null);
            }
          })
        }
        {...otherProps}
      />
      {Boolean(error) && isString(error) && (
        <FormHelperText>{error}</FormHelperText>
      )}
    </FormControl>
  );
};
